/* eslint-disable react/jsx-key */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectFileIndex, selectFilesToUpload, selectHasAssetTags, selectHasServiceTags, selectHasVulnTags, selectImportEntity, selectImportWorkspace, selectMaxSeverity, selectMinSeverity, selectResolveHost, selectUploadState } from 'store/ManageEditCreate/selectors';
import Wrapper from './styled';
import Body from './components/Body';
import Header from './components/Header';
import { uploadFile } from 'Screens/Contextualization/ManageEditCreate/actions/Actions';
import { selectProcessingQueueIsExpanded } from 'store/FileUploaderContext/selector';
import { selectTagsToAdd } from 'store/Tags/selectors';
import { buildUploadParams } from 'Screens/Contextualization/ManageEditCreate/components/ImportFileCreationModal/utils';

const FileUploadContext = () => {
  const showBody = useSelector(selectProcessingQueueIsExpanded);
  const uploadState = useSelector(selectUploadState);
  const files = useSelector(selectFilesToUpload);
  const fileIndex = useSelector(selectFileIndex);
  const resolveHost = useSelector(selectResolveHost);
  const tags = useSelector(selectTagsToAdd);
  const parsedTags = tags.map((t) => t.name).join(',');
  const workspace = useSelector(selectImportWorkspace);
  const dispatch = useDispatch();
  const hasAssetsTags = useSelector(selectHasAssetTags);
  const hasVulnsTags = useSelector(selectHasVulnTags);
  const hasServicesTags = useSelector(selectHasServiceTags);
  const minSeverity = useSelector(selectMinSeverity);
  const maxSeverity = useSelector(selectMaxSeverity);
  const importEntity = useSelector(selectImportEntity);

  useEffect(() => {
    if (uploadState === 'PROCESSED' && fileIndex >= 0) {
      const params = buildUploadParams({
        entity: importEntity,
        file: files[fileIndex],
        resolveHost,
        minSeverity,
        maxSeverity,
        hasAssetsTags,
        hasVulnsTags,
        hasServicesTags,
        tags: parsedTags
      });
      dispatch(uploadFile(params, workspace));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, uploadState]);

  return (
    <Wrapper>
      <Header showBody={ showBody } />
      {showBody && <Body /> }
    </Wrapper>
  );
};

export default FileUploadContext;
